<template>
    <div v-if="errors.length" :data-cy="`input-${name}-errors`">
        <div
            v-for="(error, errorIndex) in errors"
            :key="errorIndex"
            class="text-md mb-2 font-bold text-error"
            role="alert"
        >
            {{ error }}
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    errors: string[];
    name: string;
}>();
</script>
